import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_FINANCIAL_INDICATORS_QUERY = gql`
  query pagedFinancialIndicators($pager: PagerInputNew, $filters: FinancialIndicatorsFilterInput) {
    pagedFinancialIndicators(pager: $pager, filters: $filters) {
      total
      values {
        ...financialIndicator
      }
    } 
  }
  ${Fragments.financialIndicator}
`;

export const RAW_FINANCIAL_INDICATORS_QUERY = gql`
  query financialIndicators {
    financialIndicators {
        ...financialIndicator
    }
  }
  ${Fragments.financialIndicator}
`;

export const FINANCIAL_INDICATORS_LIST_FILTERS_QUERY = gql`
  {
    financialIndicatorsFilters @client {
      fullTextFilter {
        value
      }
      name {
        value
      }
      code {
        value
      }
    }
  }
`;
